<div>
    <mat-checkbox
            class="tc-ag-grid__checkbox"
            [class.tc-ag-grid__checkbox--error]="isError"
            [(ngModel)]="selected"
            [disabled]="disabled"
            (change)="onChange($event)"></mat-checkbox>
</div>
